// import styled from 'styled-components';
// import theme from '../../styles/theme';

// export const Container = styled.div`
//   flex-grow: 1;

//   input {
//     position: absolute;
//     left: 5px;
//     top: 5px;
//     width: 90%;
//   }

//   .rs-pagination > li.rs-pagination-btn-active > a {
//     background: ${theme.primaryColor};
//     color: #fff;
//   }
// `;

// import { Pagination } from 'rsuite';

// import styled from 'styled-components';
// import theme from '../../styles/theme';

// export const StyledPagination = styled(Pagination)`
//   .rs-pagination-btn.rs-pagination-btn-active {
//     background: ${theme.primaryColor};
//     color: white;
//   }
// `;

// export const Container = styled.div`
//   flex-grow: 1;

//   input {
//     position: absolute;
//     left: 5px;
//     top: 5px;
//     width: 90%;
//   }

//   .rs-pagination > li.rs-pagination-btn-active > a {
//     background: ${theme.primaryColor};
//     color: #fff;
//   }
//   & button {
//     border: none !important;
//   }
// `;

// export const PaginationBar = styled.div`
//   display: flex;
//   padding: 20px;
//   color: #8e8e93;
//   place-content: space-between;
//   & span {
//     align-self: center;
//     font-size: 12px;
//   }
// `;

import { Pagination } from 'rsuite';
import styled from 'styled-components';
import theme from '../../styles/theme';

export const StyledPagination = styled(Pagination)`
  .rs-pagination-btn.rs-pagination-btn-active {
    background: ${theme.primaryColor};
    color: white;
  }
`;

export const Container = styled.div`
  flex-grow: 1;

  background-color: ${props => props.darkMode === true ? '#1a1d24' : 'white'};

  border-radius: 16px;

  overflow: hidden;

  .rs-table {
    border: none !important;
  }

  .rs-table-row:hover {
    background: #f8fafc;
  }

  .rs-table-cell {
    border-right: none !important;
  }

  .rs-table-cell-header {
    background: #f8fafc;
    font-weight: 600;
    color: #475569;
  }

  .rs-table-row {
    transition: background .2s ease;
  }

  button {
    border: none !important;
  }
`;

export const PaginationBar = styled.div`
  display: flex;

  background-color: ${props => props.darkMode === true ? '#1a1d24' : 'white'};

  justify-content: space-between;

  align-items: center;

  padding: 16px 24px;


  color: #64748b;

  border-top: 1px solid #e2e8f0;

  span {
    font-size: 13px;
  }
`;
